<aside class="menu" [ngClass]="{'is-active': isMenuOpen}">
    @for (menuItem of itemsMenu; track menuItem.name) {
      <div class="section-links">
        <div class="section-container">
          @for (box of menuItem.boxes; track box.name) {
            <div>
              <div class="option-boxes">
                <a class="option-box" [routerLink]="box.routerLink" [class.is-active-link]="isActiveLink(box)">
                  <fa-duotone-icon class="box-icon" [icon]="box.icon"></fa-duotone-icon>
                  <span class="box-title">{{ box.nameLong ? box.nameLong : box.name }}</span>
                </a>
              </div>
            </div>
          }
        </div>
      </div>
    }
</aside>
  